import { selectBlocks } from './selectBlocks';

export const selectDealerBlock = state => selectBlocks(state).dealer_block || {};
